// @flow
import React, {useDeferredValue, useEffect, useState} from 'react';
import * as PropTypes from 'prop-types';
import $ from "jquery";
import ArchiverClientApi from "../API/archiverClientApi";
import LoadingSpinner from "../GUI_COMMON/COMPONENTS/LoadingSpinner";
import ArchiverGuiUtils from "../SUPPORT/ArchiverGuiUtils";

const CaseFind = ({name, onItemSelected, required=false, readOnly=false}) => {

    const MIN_NUM_CHARS_NEEDED_TO_SEARCH=2;         // min length to do the search send and results show
    const MAX_NUM_RESULTS_AT_A_TIME=5;          // show this many search results at a time only

    const [searchResults, setSearchResults] = useState([]);
    const [searchTextField, setSearchTextField] = useState("");
    const [inputClass] = useState("form-control");
    const [isSearching, setIsSearching] = useState(false);
    
    const [searchTerm, setSearchTerm] = useState("");
    const deferredSearchTerm = useDeferredValue(searchTerm);
    
    useEffect( () => {
        doSearchAtArchiver(deferredSearchTerm);
    },[deferredSearchTerm]);
    
    function handleSearchCases(e) {
        e.preventDefault();
        e.stopPropagation();

        const searchTerm=getSearchTerm();
        if(!searchTerm || searchTerm==="" || searchTerm===" ") {
            return;
        }
        doSearchAtArchiver(searchTerm);
    }
    
    function doSearchAtArchiver(theSearchTerm:string) {
        if(!theSearchTerm || theSearchTerm==="" || theSearchTerm===" ") {
            return;
        }
        setIsSearching(true);

        ArchiverClientApi.sendCaseSearchRequest(theSearchTerm,0,MAX_NUM_RESULTS_AT_A_TIME)
        .then( results => {
            setSearchResults(results);
        })
        .catch( responseError => ArchiverGuiUtils.ShowErrorIfNotUnauthourized(responseError))
        .finally( () => setIsSearching(false));
    }
    
    function handleSearchKeyUp(event) {
        event.preventDefault();
        event.stopPropagation();

        if (event.code === 'Enter' && searchResults.length > 0) { // enter selects the first item in the list
            const firstQueryListItem = document.querySelector("#caseQueryListCard li:first-child");
            firstQueryListItem.click();
            return;
        }

        const theSearchTerm = getSearchTerm();
        if(theSearchTerm.length >= MIN_NUM_CHARS_NEEDED_TO_SEARCH) {
            setSearchTerm(getSearchTerm());
        }
    }
    
    function getSearchTerm() {
        const term = $("#caseSearchInput").val();
        return(term);
    }
    
    function handleItemClicked(e, item) {
        if(onItemSelected) {
            e.target.name=name;  // fake for our parent handler
            e.target["item"]=item;
            onItemSelected(e);
        }
        setSearchResults([]); // make the list go away
        setSearchTextField(item.number);
    }
    
    function handleSearchTextChanged(e) {
        const value = e.target.value;
        if(value.length < MIN_NUM_CHARS_NEEDED_TO_SEARCH) {
            setSearchResults([]);
        }
        setSearchTextField(value);
    }
    
    function showListDivIfRequired() {
        if(searchResults.length===0) {
            return null;
        }
        return(
            <div className="card" id="caseQueryListCard">
                <div style={{zIndex:"1000", overflow:"auto", height:"200px", width:"100%", position:"absolute"}}>
                    <ul className="list-group">
                        {searchResults.map( (item) =>
                            <li key={item.id} className="list-group-item li-contact-search-item" 
                                onClick={(e)=>handleItemClicked(e,item)}>{item.number}</li>
                        )}
                    </ul>
                </div>
            </div>
        );
    }
    
    return (
        <div className="form-group mb-0">
            <div className="input-group">
            <input type="text" className={inputClass} id="caseSearchInput"
                   placeholder="case #"
                   onKeyUp={handleSearchKeyUp}
                   aria-describedby="inputGroupPrepend"
                   value={searchTextField}
                   onChange={handleSearchTextChanged}
                   autoComplete="off"
                   required={required} readOnly={readOnly}/>
            <div className="input-group-append">
                <button type="button" id="caseSearchBTN" disabled={readOnly} className="li-button li-primary li-search-button" onClick={handleSearchCases}>
                    {isSearching && <LoadingSpinner small/>}
                    {!isSearching && <i className="fa fa-lg fa-search"/>}
                </button>
            </div>
            </div>
            {showListDivIfRequired()}
        </div>
    );
};

CaseFind.propTypes = {
    onItemSelected: PropTypes.func.isRequired,
    required: PropTypes.bool,
    goodNess: PropTypes.string,
    focus: PropTypes.bool,
    readOnly: PropTypes.bool,
    name: PropTypes.string.isRequired,
};

export default CaseFind;